<template>
	<div class="main-page-wrapper p0 overflow-hidden">
		<div class="error-page d-lg-flex align-items-center">
			<div class="img-holder order-lg-last">
				<img src="/images/pages/404/404.png" alt="404" class="w-100 illustration" />
			</div>
			<div class="text-wrapper order-lg-first">
				<h1 class="font-slab">
					Oops! La page que vous recherchez n'existe pas.
				</h1>
				<p class="font-rubik">
					Il semble que vous ayez suivi un lien brisé ou que la page ait été déplacée.
				</p>
				<NuxtLink to="/" class="d-flex align-items-center justify-content-center contact">
					Revenir a la page d'accueil <i class="fa-solid fa-arrow-right ms-3"></i>
				</NuxtLink>
			</div>
			<!-- /.text-wrapper -->
		</div>
	</div>
</template>

<script setup>
</script>

<style scoped>
.error-page .img-holder .illustration {
	min-height: 40vh;
}
</style>
